import React, { useEffect, useRef, useState } from "react";
import * as d3 from "d3";

const HorizontalBarChart = ({ data, setup }) => {
  const svgRef = useRef();
  const wrapperRef = useRef();
  const [containerWidth, setContainerWidth] = useState(800);

  // Resize observer
  useEffect(() => {
    const handleResize = () => {
      if (wrapperRef.current) {
        setContainerWidth(wrapperRef.current.offsetWidth);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!data || data.length === 0) return;
    const margin = { top: 40, right: 120, bottom: 40, left: 120 };
    const width = containerWidth - margin.left - margin.right;
    const barHeight = 30;
    const height = data.length * (barHeight + 10);
    const total = d3.sum(data, d => d.value);

    const svg = d3
      .select(svgRef.current)
      .attr("viewBox", `0 0 ${containerWidth} ${height + margin.top + margin.bottom}`)
      .attr("preserveAspectRatio", "xMidYMid meet");

    svg.selectAll("*").remove();

    const chart = svg
      .append("g")
      .attr("transform", `translate(${margin.left},${margin.top})`);

    const y = d3
      .scaleBand()
      .domain(data.map(d => d.name))
      .range([0, height])
      .padding(0.1);

    const x = d3
      .scaleLinear()
      .domain([0, d3.max(data, d => d.value)])
      .nice()
      .range([0, width]);

    const colorScale = d3
      .scaleOrdinal(d3.schemeCategory10)
      .domain(data.map(d => d.name));

    // Dibujar barras con animación
    chart
      .selectAll(".bar")
      .data(data)
      .enter()
      .append("rect")
      .attr("class", "bar")
      .attr("y", d => y(d.name))
      .attr("height", y.bandwidth())
      .attr("x", 0)
      .attr("width", 0)
      .attr("fill", d => colorScale(d.name))
      .transition()
      .duration(800)
      .attr("width", d => x(d.value));

    // Etiquetas al final de las barras
    chart
      .selectAll(".label")
      .data(data)
      .enter()
      .append("text")
      .attr("x", 0)
      .attr("y", d => y(d.name) + y.bandwidth() / 2)
      .attr("dy", ".35em")
      .style("font-size", "12px")
      .transition()
      .delay(800)
      .text(d => setup !== undefined && !setup.percentage ? d.value: `${d.value} (${((d.value / total) * 100).toFixed(1)}%)`)
      .attr("x", d => x(d.value) + 5);

    chart
      .selectAll(".name-label")
      .data(data)
      .enter()
      .append("foreignObject")
      .attr("x", -margin.left)
      .attr("y", (d) => y(d.name))
      .attr("width", margin.left - 10)
      .attr("height", y.bandwidth())
      .append("xhtml:div")
      .attr("class", "label-html")
      .style("display", "flex")
      .style("align-items", "center")
      .style("justify-content", setup !== undefined && setup.justifyContentLabel === "center"? "center":"space-between")
      .style("height", `${y.bandwidth()}px`)
      .html((d) => d.name);

  }, [data, containerWidth, setup]);

  return (
    <div ref={wrapperRef} style={{ width: "100%" }}>
      <svg ref={svgRef} style={{ width: "100%", height: "auto" }} />
    </div>
  );
};

export default HorizontalBarChart;
